import { defineMessages } from 'react-intl';
export default defineMessages({
  buttonLabel: {
    id: "ResendVismaSignInvitation.buttonLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Resend invitation"
    }]
  },
  dialogTitle: {
    id: "ResendVismaSignInvitation.dialogTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Resend Visma Sign invitation"
    }]
  },
  dialogDescription: {
    id: "ResendVismaSignInvitation.dialogDescription",
    defaultMessage: [{
      "type": 0,
      "value": "Select the existing signers who should receive the invitation again."
    }]
  },
  resendLabel: {
    id: "ResendVismaSignInvitation.resendLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Resend"
    }]
  },
  signedStatus: {
    id: "ResendVismaSignInvitation.signedStatus",
    defaultMessage: [{
      "type": 0,
      "value": "Signed"
    }]
  },
  cancelledStatus: {
    id: "ResendVismaSignInvitation.cancelledStatus",
    defaultMessage: [{
      "type": 0,
      "value": "Cancelled"
    }]
  },
  unavailableStatus: {
    id: "ResendVismaSignInvitation.unavailableStatus",
    defaultMessage: [{
      "type": 0,
      "value": "Unavailable"
    }]
  },
  requestFailed: {
    id: "ResendVismaSignInvitation.requestFailed",
    defaultMessage: [{
      "type": 0,
      "value": "The invitation could not be resent. Please try again."
    }]
  }
});